import { preferredEnv, storageKey } from './config'

export function readSession() {
  try {
    return JSON.parse(window.localStorage.getItem(storageKey) || '{}')
  } catch (_) {
    return {}
  }
}

export function saveSession(next) {
  const current = readSession()
  window.localStorage.setItem(storageKey, JSON.stringify({ ...current, ...next }))
}

export function clearSession() {
  window.localStorage.removeItem(storageKey)
}

export function sessionIsValid(session = readSession()) {
  return Boolean(
    session.jwt
    && session.env === preferredEnv()
    && (!session.jwtExp || Date.now() < Number(session.jwtExp)),
  )
}
